import { register } from 'tmr/tmr/ngModuleRegistry'

import * as dialog from './dialog/dialog'
import * as mdChipsCtrl from './mdChipsCtrl/mdChipsCtrl'
import * as operation from './operation/operation'
import * as operationChecklist from './operation/checklistOperation'
import * as resourceForm from './resourceForm/resourceForm'

export default register(
  'tmr.core.controllers',
  dialog,
  mdChipsCtrl,
  operation,
  operationChecklist,
  resourceForm
)
